import { CricketIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const PenaltyPopup = new PopupBuilder('Penalty', {
  incident_id: CricketIncidentId.Penalty,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
